import { LinkGroup } from '@components/linkGroup';
import { LinkListGroup } from '@components/linkListGroup';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  LinkGroup,
  LinkListGroup,
};
